import request from '@/utils/request'

// 查询撤离路线列表
export function listCllx(query) {
  return request({
    url: '/zhfy/cllx/list',
    method: 'get',
    params: query
  })
}

// 查询撤离路线详细
export function getCllx(id) {
  return request({
    url: '/zhfy/cllx/' + id,
    method: 'get'
  })
}

// 新增撤离路线
export function addCllx(data) {
  return request({
    url: '/zhfy/cllx',
    method: 'post',
    data: data
  })
}

// 修改撤离路线
export function updateCllx(data) {
  return request({
    url: '/zhfy/cllx',
    method: 'put',
    data: data
  })
}

// 删除撤离路线
export function delCllx(id) {
  return request({
    url: '/zhfy/cllx/' + id,
    method: 'delete'
  })
}
